/**
 * Shows/hides the lip balm production-delay notice based on which shade is
 * currently selected — only Rosy (variant id 48518957039862) and Cherry
 * (variant id 48518957105398) are affected; Maple and Tulip ship normally.
 *
 * DETECTION:
 * Confirmed on the live page that selecting a shade updates the URL's
 * `?variant=<id>` query param (via history.pushState/replaceState, without a
 * full page reload) — that's the most reliable signal available, since it's
 * the real variant id rather than something inferred from the swatch
 * picker's internal markup/state (which didn't pan out — see prior version
 * of this file for why the name-based approach didn't work here).
 *
 * This reads `?variant=` on load, and re-checks it three ways to make sure
 * nothing is missed regardless of exactly how the theme triggers the URL
 * update: (1) shortly after any radio `change` event, (2) by wrapping
 * history.pushState/replaceState directly so the URL change itself triggers
 * a re-check, and (3) on `popstate` for back/forward navigation.
 *
 * Affected variant ids come from the notice element's data-affected-variants
 * attribute (set in buybox-notice.liquid), so they can be changed without
 * touching this file.
 */
(function () {
  var notice = document.getElementById('gwp-lip-balm-notice');
  if (!notice) return;

  var affected = (notice.getAttribute('data-affected-variants') || '')
    .split(',')
    .map(function (s) {
      return s.trim();
    })
    .filter(Boolean);

  function getCurrentVariantId() {
    var params = new URLSearchParams(window.location.search);
    return params.get('variant');
  }

  function refresh() {
    var current = getCurrentVariantId();
    notice.style.display = current && affected.indexOf(String(current)) !== -1 ? '' : 'none';
  }

  refresh();

  // Selecting a swatch fires a native 'change' event on its radio input;
  // give the theme's own JS a brief moment to update the URL afterward.
  document.addEventListener('change', function (e) {
    if (e.target && e.target.matches && e.target.matches('input[type="radio"]')) {
      setTimeout(refresh, 100);
    }
  });

  // Belt-and-braces: catch the URL update directly, regardless of what
  // triggers it.
  ['pushState', 'replaceState'].forEach(function (method) {
    var original = history[method];
    history[method] = function () {
      var result = original.apply(this, arguments);
      refresh();
      return result;
    };
  });

  window.addEventListener('popstate', refresh);
})();